import { createSlice } from './index';

export const pcsChartsSlice = createSlice({
  name: 'pcsCharts',

  initialState: {
    host: null,
    materials: [],
    interval: null,
    startDate: null,
    endDate: null,
    timeInterval: null,
  },

  reducers: create => ({
    resetStore: () => {
      return pcsChartsSlice.getInitialState();
    },

    changeValue: create.preparedReducer(
      (key, value) => {
        return { payload: { key, value } };
      },
      (state, action) => {
        state[action.payload.key] = action.payload.value;
      }
    ),

    changeSeveralValues: (state, action) => {
      for (const key in action.payload) {
        state[key] = action.payload[key];
      }
    },
  }),
});
